'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _user = require('./user.factory');

var _user2 = _interopRequireDefault(_user);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userModule = _angular2.default.module('user', []).factory('User', _user2.default);

exports.default = userModule;


// WEBPACK FOOTER //
// ./client/app/common/user/user.js